import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export const navigationBarMain = (): void => {
  const navigationBarMain = document.querySelector('.js-navigation-bar-main');
  const navigationMobileTrigger = document.querySelector('.js-navigation-mobile-trigger');

  if (!navigationBarMain || !navigationMobileTrigger) {
    return;
  }

  window.addEventListener('load', () => {
    document.body.classList.add('loaded');
  });

  window.addEventListener('scroll', () => {
    if (window.scrollY > 56) {
      document.body.classList.add('page-scrolled');
    } else {
      document.body.classList.remove('page-scrolled');
    }
  });

  navigationMobileTrigger.addEventListener('click', () => {
    document.body.classList.toggle('menu-active');
  });

  // gsap.to(navigationBarMain, {
  //   paddingTop: '24px',
  //   paddingBottom: '24px',
  //   backgroundColor: 'var(--color-blue-1000)',
  //   duration: 0.3,
  //   scrollTrigger: {
  //     trigger: navigationBarMain,
  //     start: 'top top',
  //     end: 'bottom top',
  //     toggleActions: 'play none reverse none',
  //   },
  // });
};
